const urlHosts = {
  development: 'http://localhost:4000',
  staging: 'https://api-staging.williamhunting.blog',
  sandbox: 'https://api.williamhunting.blog',
  production: 'https://api.extra.app'
};
export default urlHosts;